import { graphql } from '@graphql/gql';

export const UPDATE_ATTENDEE_COMPLIANCE = graphql(`
  mutation UPDATE_ATTENDEE_COMPLIANCE {
    updateAttendeeCompliance {
      requestReceived
    }
  }
`);
